import { trackContactFormLead } from '@/components/ContactForm/contact-form-tracking-events';
import { ContactFormLeadAction, InteractionEvent } from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export const GALLERY_CONTACT_EVENT_LABEL = 'pdp_gallery';
export const GALLERY_CONTACT_FORM_LEAD_LABEL = 'sendMessage_ok';
export const GALLERY_CONTACT_FORM_CONVERSION_SOURCE = 'gallery';
export const GALLERY_CONTACT_MODAL_DISPLAY_ACTION = 'display_lead_modal';
export const GALLERY_CONTACT_OPEN_FORM_ACTION = 'open_formlead_modal';

const GALLERY_CONTACT_MODAL_DISPLAY_SESSION_KEY_PREFIX = 'galleryContactModalDisplayed:';

let isGalleryContactEntryActive = false;

export function activateGalleryContactEntry(): void {
  isGalleryContactEntryActive = true;
}

export function deactivateGalleryContactEntry(): void {
  isGalleryContactEntryActive = false;
}

export function isGalleryContactEntry(): boolean {
  return isGalleryContactEntryActive;
}

function hasTrackedGalleryContactModalDisplay(listingId: string): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  return (
    sessionStorage.getItem(`${GALLERY_CONTACT_MODAL_DISPLAY_SESSION_KEY_PREFIX}${listingId}`) ===
    '1'
  );
}

function markGalleryContactModalDisplayTracked(listingId: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  sessionStorage.setItem(`${GALLERY_CONTACT_MODAL_DISPLAY_SESSION_KEY_PREFIX}${listingId}`, '1');
}

/** Push once per listing per session when the gallery contact slide becomes active. */
export function trackGalleryContactModalDisplayed(listingId: string): void {
  if (typeof window === 'undefined' || hasTrackedGalleryContactModalDisplay(listingId)) {
    return;
  }

  trackEventHarmonized(InteractionEvent.FEATURE_DISPLAYED, {
    h_event_category_006: InteractionEvent.FEATURE_DISPLAYED,
    h_event_action_007: GALLERY_CONTACT_MODAL_DISPLAY_ACTION,
    h_event_label_008: GALLERY_CONTACT_EVENT_LABEL,
  });
  markGalleryContactModalDisplayTracked(listingId);
}

/** Push on every Email CTA click in the image gallery. */
export function trackGalleryContactCtaClick(): void {
  if (typeof window === 'undefined') {
    return;
  }

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_action_007: GALLERY_CONTACT_OPEN_FORM_ACTION,
    h_event_label_008: GALLERY_CONTACT_EVENT_LABEL,
  });
}

export function trackGalleryContactFormLead(
  action: ContactFormLeadAction,
  contactInquiryId: string | undefined,
  isLeadOfferSale: boolean,
  leadsStatus: 'verified' | 'not_verified',
  hasExtraInformation = false,
  isFormSubmittedwithProfileId?: boolean,
): void {
  trackContactFormLead(
    action,
    contactInquiryId,
    isLeadOfferSale,
    leadsStatus,
    hasExtraInformation,
    isFormSubmittedwithProfileId,
    GALLERY_CONTACT_FORM_CONVERSION_SOURCE,
    GALLERY_CONTACT_FORM_LEAD_LABEL,
  );
}
